import * as CryptoJS from 'crypto-js';
import { CipherModel } from './cipher.model';

export default class AesBuilder {
  private secretKey: string;

  constructor(secretKey?: string) {
    // You can replace this default key with an environment variable or config
    this.secretKey = secretKey || 'default-strong-secret-key';
  }

  /**
   * Encrypt plain text into AES ciphertext (Base64)
   */
  encrypt(plainText: string): string {
    try {
      if (!plainText) return '';
      const encrypted = CryptoJS.AES.encrypt(plainText, this.secretKey).toString();
      return encrypted;
    } catch (err) {
      console.error('Encryption failed:', err);
      return '';
    }
  }

  /**
   * Decrypt AES ciphertext back into plain text
   */
  decrypt(cipherText: string): string {
    try {
      if (!cipherText) return '';
      const bytes = CryptoJS.AES.decrypt(cipherText, this.secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted;
    } catch (err) {
      console.error('Decryption failed:', err);
      return '';
    }
  }

  async hashValue(value: any): Promise<string> {
    //  debugger;
    // Serialize the input value to a JSON string
    const jsonString = JSON.stringify(value);
    const encoder = new TextEncoder();
    const data = encoder.encode(jsonString);

    const hashkey = await this.generateHashKey();
    const signature = await window.crypto.subtle.sign(
      String(CipherModel.HASH_NAME),
      hashkey,
      data
    );
    return this.arrayBufferToBase64(signature);
  }

  private async generateHashKey(): Promise<CryptoKey> {
        // debugger;
    const encoder = new TextEncoder();
    const hashData = encoder.encode(CipherModel.HASH_KEY);
    return  await window.crypto.subtle.importKey(
      'raw',
      hashData,
      { name: String(CipherModel.HASH_NAME) , hash: String(CipherModel.HASH_TYPE) },
      false,
      ['sign']
    );
  }

  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
  
}